import { Modal as CompassModal } from "@circleco/compass/components/Modal";
import type { ReactNode } from "react";

import { toCompassVariant } from "../modalHelpers";

interface CompassActionModalProps {
  actionText?: string;
  actionVariant?: "primary" | "danger" | "circle";
  cancelText?: string;
  children: ReactNode;
  description?: string;
  disabled?: boolean;
  formId?: string;
  isCancelDisabled?: boolean;
  isFullWidthAction?: boolean;
  isOpen?: boolean;
  loading?: boolean;
  onAction?: () => void;
  onClose?: () => void;
  size?: "sm" | "md" | "lg";
  title: string;
}

export const CompassActionModal = ({
  actionText,
  actionVariant = "primary",
  isCancelDisabled = false,
  cancelText,
  children,
  disabled = false,
  formId,
  isFullWidthAction = false,
  isOpen = false,
  onAction,
  onClose,
  size = "md",
  title,
  description,
  loading = false,
}: CompassActionModalProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose?.();
    }
  };

  const handlePrimaryClick = () => {
    onAction?.();
  };

  const compassVariant = toCompassVariant(actionVariant);

  return (
    <CompassModal.Root
      open={isOpen}
      onOpenChange={handleOpenChange}
      size={size}
    >
      <CompassModal.Content>
        <CompassModal.Header
          title={title}
          description={description}
          showCloseButton={!!onClose}
        />
        <CompassModal.Body>{children}</CompassModal.Body>
        {actionText && (
          <CompassModal.Footer
            layout={isFullWidthAction ? "full-width" : "default"}
            primaryAction={{
              label: actionText,
              variant: compassVariant,
              disabled,
              onClick: handlePrimaryClick,
              type: formId ? "submit" : "button",
              form: formId,
              loading,
            }}
            secondaryAction={
              cancelText
                ? {
                    label: cancelText,
                    onClick: onClose,
                    shouldCloseModal: !isCancelDisabled,
                  }
                : undefined
            }
          />
        )}
      </CompassModal.Content>
    </CompassModal.Root>
  );
};
